import { createBrowserRouter } from 'react-router-dom';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { LoginPage } from './pages/LoginPage';
import { CallbackPage } from './pages/CallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { CredentialsPage } from './pages/CredentialsPage';
import { CredentialDetailPage } from './pages/CredentialDetailPage';
import { DomainsPage } from './pages/DomainsPage';
import { DomainDetailPage } from './pages/DomainDetailPage';
import { SubdomainDetailPage } from './pages/SubdomainDetailPage';
import { SettingsPage } from './pages/SettingsPage';

/**
 * Admin Console route configuration using createBrowserRouter (data router pattern).
 * Public routes (/login, /callback) are top-level.
 * Protected routes are children of AuthenticatedLayout which enforces authentication
 * and renders child routes via <Outlet />.
 *
 * Route tree:
 *   /admin-console                     → DashboardPage
 *   /admin-console/domains             → DomainsPage (card grid)
 *   /admin-console/domains/:domainId   → DomainDetailPage (metadata + subdomain list)
 *   /admin-console/domains/:domainId/subdomains/:subdomainId → SubdomainDetailPage
 *   /admin-console/credentials         → CredentialsPage (card grid)
 *   /admin-console/credentials/:credentialId → CredentialDetailPage
 *   /admin-console/settings            → SettingsPage
 *
 * Role-based access control is handled within each page component:
 * - CredentialsPage: System_Admin only, shows auth error to Domain_Admin
 * - DomainsPage: System_Admin create, Domain_Admin view (scoped)
 * - SettingsPage: System_Admin only
 *
 * Requirements: 10.1, 10.3
 */
export const router = createBrowserRouter([
  {
    path: '/admin-console/login',
    element: <LoginPage />,
  },
  {
    path: '/admin-console/callback',
    element: <CallbackPage />,
  },
  {
    path: '/admin-console',
    element: <AuthenticatedLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'domains',
        element: <DomainsPage />,
      },
      {
        path: 'domains/:domainId',
        element: <DomainDetailPage />,
      },
      {
        path: 'domains/:domainId/subdomains/:subdomainId',
        element: <SubdomainDetailPage />,
      },
      {
        path: 'credentials',
        element: <CredentialsPage />,
      },
      {
        path: 'credentials/:credentialId',
        element: <CredentialDetailPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
]);
